module.exports = __webpack_public_path__ + "img/sp06.5978a7e0.png";